

export const Work = [
    {
      id:1,
        name:"Campaign Smart Contract",
        description:["Crowdfunding smart contract. Donate to campaign and vote. Made with Solidity, web3, Next.js on Rinkeby Ethereum test network."],
       
        imgSrc: 'https://github.com/marins1897/PortfolioMS/blob/main/src/data/DataImages/Campaign.jpg?raw=true',
        demo:"",
        github:"https://github.com/marins1897/campaign-SmartContract",
        type : "blockchain"
    },
    {
        id:4,
        name:"Food Bonnie App",
        description:["Order food App, with cart, list of meals and detail of order. Build with React.js and Firebase."],
       
       
       
        imgSrc:'https://github.com/marins1897/FoodBonnieApp/blob/main/FoodApp.jpg?raw=true',
        
        demo:"https://food-bonnie-app.vercel.app/",
        github:"https://github.com/marins1897/FoodBonnieApp",
        type : "react"
        
    },
    {
        id:6,
        name:"NK Croatia Zmijavci",
        description:["Unofficial website for football club build using PHP, HTML, Javascript and MySql. Admin dashboard with Publish, Edit and Delete Post, User, Match.."],
       
        imgSrc:'https://github.com/marins1897/CroatiaZ/blob/main/NKCroatia1.jpg?raw=true',
        demo:"http://www.nkcroatiazmijavci.rf.gd/",
        github:"https://github.com/marins1897/CroatiaZ",
        type : ""
       
    },
    {
        id:34,
        name:"Azra Music Player",
        description:["Listen to the best song of famous Azra band. More than 200 songs. Play, pause, next, previous song."],
       
        imgSrc:'https://github.com/marins1897/azra-player_Svelte/blob/master/azra_app.png?raw=true',
        demo:"https://azra-player-h7an2oyl9-marins1897.vercel.app/",
        github:"https://github.com/marins1897/azra-player_Svelte",
        type : "svelte"
    },
    {
        id:28,
        name:"Places App",
        description:["Add your Favorite place by taking an image, pick location or set it manually. React Native device features (Camera, Location) and Expo. App Builded, Published and Downloaded Locally APK."],
       
        imgSrc:'https://raw.githubusercontent.com/marins1897/rn-places-app/main/rn_places-app.png',
        demo:"",
        github:"https://github.com/marins1897/rn-places-app",
        type : "react-native"
    },
    {
        id:41,
          name:"DeFi dApp",
          description:["Smart Contract writen in Solidity, compiled and deployed using Hardhat and Alchemy node provider. Decentralized application builded with ethers.js and React."],
         
          imgSrc: 'https://github.com/marins1897/DeFi_dApp/blob/master/defi_dApp.png?raw=true',
          demo:"",
          github:"https://github.com/marins1897/DeFi_dApp",
          type : "blockchain"
    },
    {
        id:5,
        name:"Redux Shop",
        description:["A small React Redux shop with Firebase. Message about cart state displayed in case of Error, Sending or Success message."],
       
        imgSrc:'https://github.com/marins1897/ReduxShop/blob/main/Redux-Shop.jpg?raw=true',
        demo:"https://redux-shop-six.vercel.app//",
        github:"https://github.com/marins1897/ReduxShop",
        type : "react"
    },
    {
        id:7,
        name:"Meetups App",
        description:["Fill the form with new Meetup. List of inputed Meetups displayed on Main Page. Build using Next.js and MongoDB. "],
       
        imgSrc:'https://github.com/marins1897/meetups-nextjs/blob/main/Meetups-NextJS.jpg?raw=true',
        demo:"https://meetups-nextjs-ashen.vercel.app/",
        github:"https://github.com/marins1897/meetups-nextjs",
     
        type : "react"
    },
    {
        id:29,
        name:"Guess Game",
        description:["Pick a number between 1 - 99. Machine will try to guess it. Deeper React Native layouts, comnponents, styles and UIs."],
       
        imgSrc:'https://github.com/marins1897/Guess_game-React-Native/blob/master/guess_game_rn.png?raw=true',
        demo:"",
        github:"https://github.com/marins1897/Guess_game-React-Native",
        type : "react-native"
    },
    {
        id:8,
        name:"Quotes SPA",
        description:["Quotes Single Page Application builded using React Router and Firebase. Sort Qoutes, Add New Quote, Load and Add Comments."],
       
        imgSrc:'https://github.com/marins1897/Quotes-SPA/blob/main/Quotes.jpg?raw=true',
        demo:"https://router-95b86.web.app/quotes",
        github:"https://github.com/marins1897/Quotes-SPA",
        type : "react"
    },
    {
        id:35,
        name:"Meet Us App",
        description:["Meetup App build using Svelte. Display list of all MeetUps, mark sa an favorite. Deep dive into Svelte components."],
       
        imgSrc:'https://github.com/marins1897/meet_us-svelte/blob/master/s_meetups.png?raw=true',
        demo:"https://meet-65kdr86d3-marins1897.vercel.app/",
        github:"https://github.com/marins1897/meet_us-svelte",
        type : "svelte"
    },
    {
      id:2,
        name:"Lottery Smart Contract",
        description:["Buy lottery ticket and be a winner. Contract written in Solidity, compiled and deployed using solc package. Deployed to Ethereum test network using Truffle and infura provider. Decentralized application using web3.js library and React. Tested using Mocha framework. "],
       
        imgSrc: 'https://github.com/marins1897/lottery_dapp/blob/master/lottery_dapp.png?raw=true',
        demo:"",
        github:"https://github.com/marins1897/lottery_dapp",
        type : "blockchain"
    },
    {
        id:3,
        name:"News AI App",
        description:["AI App build in React.js with Alan AI. Search news by voice. Talk with App. Search by categories, terms or sources. Chat with AI."],
       
        imgSrc: 'https://github.com/marins1897/NewsAI-React/blob/main/NewsAI.jpg?raw=true',
        demo:"https://news-ai-react.vercel.app/",
        github:"https://github.com/marins1897/NewsAI-React",
        type : "react"
    },
    {
        id:30,
        name:"Meals App",
        description:["App for recipes, setting Favorite Meals. React Native Navigation, stack, drawers, tabs. Hamburger menu. "],
       
        imgSrc:'https://github.com/marins1897/Food-App-React_Native/blob/master/rn_meals_app.png?raw=true',
        demo:"",
        github:"https://github.com/marins1897/Food-App-React_Native",
        type : "react-native"
    },
    {
        id:9,
        name:"Weather App",
        description:["Weather forecast App. Display current weather in typed city and forecast for next few days. Build with React.js and Bootstrap."],
       
        imgSrc:'https://github.com/marins1897/WeatherApp/blob/main/Weather.jpg?raw=true',
        demo:"https://weather-app-bice-nu.vercel.app/",
        github:"https://github.com/marins1897/WeatherApp",
        type : "react"
    },{
        id:10,
        name:"Expense Filter App",
        description:["App build in React.js. With add new expense funcionallity, expenses filtered by month."],
       
        imgSrc: 'https://github.com/marins1897/Expenses-filter/blob/main/ExpensesFilter111.jpg?raw=true',
        demo:"https://expenses-filter-orpin.vercel.app/",
        github:"https://github.com/marins1897/Expenses-filter",
        type : "react"
    },
    {
        id:36,
        name:"Tic Tac Toe App",
        description:["Tic Tac Toe App builded using Svelte."],
       
        imgSrc:'https://github.com/marins1897/TicTacToe-Svelte/blob/master/S_TicTacToe.png?raw=true',
        demo:"https://tic-tac-8ob6d5wxs-marins1897.vercel.app/",
        github:"https://github.com/marins1897/TicTacToe-Svelte",
        type : "svelte"
    },
    {
        id:11,
        name:"Movie App",
        description:["Add Movie Title, Opening text and Release date. Movie will be added to Firebase, fetched from there and displayed."],
       
        imgSrc:'https://github.com/marins1897/add-fetch-Movie-http/blob/main/Movie.jpg?raw=true',
        demo:"https://add-fetch-movie-http.vercel.app/",
        github:"https://github.com/marins1897/add-fetch-Movie-http",
        type : "react"
    },
    {
        id:12,
        name:"Personal Portfolio App",
        description:["Personal portfolio made by using React.js , styled components and React Motion."],
       
        imgSrc:'https://github.com/marins1897/PortfolioMS/blob/main/PortfolioMS.jpg?raw=true',
        demo:"https://marin-portfolio1897.vercel.app/",
        github:"https://github.com/marins1897/PortfolioMS",
        type : "react"
    },
    {
        id:31,
        name:"Tracker App",
        description:["Expense Tracker React Native Mobile App with Expo. Add new Expense, fetch All expenses, expenses from last week. App wide state managament. "],
       
        imgSrc:'https://github.com/marins1897/Expense-Tracker-RN/blob/master/rn_expenses.png?raw=true',
        demo:"",
        github:"https://github.com/marins1897/Expense-Tracker-RN",
        type : "react-native"
    },
    {
        id:13,
        name:"Authentication App",
        description:["React Authentication App with Firebase and Firebase REST API. Using the token for request to protected resources and adding auto log out."],
       
        imgSrc:'https://github.com/marins1897/Authentication/blob/main/Authentication.jpg?raw=true',
        demo:"https://authentication-nine.vercel.app/",
        github:"https://github.com/marins1897/Authentication",
        type : "react"
    },
    {
        id:40,
          name:"Balance & Transfer dApp",
          description:["Solidity Smart Contract for checking balance and making transfer of Token, compiled and deployed to Goerli using Hardhat, Infura and Metamask. Frontend builded with ethers.js and React."],
         
          imgSrc: 'https://github.com/marins1897/hardhat_balance/blob/master/hardhat_dApp.png?raw=true',
          demo:"",
          github:"https://github.com/marins1897/hardhat_balance/",
          type : "blockchain"
    },
    {
        id:14,
        name:"To Do App",
        description:["To Do App builded with Typescript and React.js."],
       
        imgSrc:'https://github.com/marins1897/ToDoApp-Typescript/blob/main/ToDoTypeScript.jpg?raw=true',
        demo:"https://to-do-app-typescript.vercel.app/",
        github:"https://github.com/marins1897/ToDoApp-Typescript",
        type : "react"
    },
    {
        id:38,
        name:"Shop App",
        description:["Shop App builded by using writable and readable Svelte stores. Subscribed to store and create, read data. "],
       
        imgSrc:'https://github.com/marins1897/svelte_stores/blob/master/s_stores.png?raw=true',
        demo:"https://msapp-qbqzz6yhz-marins1897.vercel.app/",
        github:"https://github.com/marins1897/svelte_stores",
        type : "svelte"
    },
    {
        id:33,
        name:"RN Authentication",
        description:["Signing Users Up & Logging in. Managing Authentication Status. Storing Authentication Status on the Device with Context. Build with Firebase Authentication. Protecting Screens. Auth Tokens."],
       
        imgSrc:'https://github.com/marins1897/User-Authentication-RN/blob/master/rn_authentication.png?raw=true',
        demo:"",
        github:"https://github.com/marins1897/User-Authentication-RN",
        type : "react-native"
    },
    {
        id:37,
        name:"To Do App",
        description:["To Do App builded using Svelte. Add new Task, mark is as Completed. Delete Task."],
       
        imgSrc:'https://github.com/marins1897/ToDo-Svelte/blob/main/s_todo.png?raw=true',
        demo:"https://to-do-svelte.vercel.app/",
        github:"https://github.com/marins1897/ToDo-Svelte",
        type : "svelte"
    },
    {
        id:39,
          name:"Storage dApp",
          description:["Simple Storage Solidity Smart Contract deployed to Goerli Ethereum test network by using Alchemy and Metamask. Contract compiled and deployed using Truffle tool, communication layer via web3.js library."],
         
          imgSrc: 'https://github.com/marins1897/truffle_dapp/blob/master/truffle_dapp.png?raw=true',
          demo:"",
          github:"https://github.com/marins1897/truffle_dapp",
          type : "blockchain"
    },
    {
        id:15,
        name:"Redux Auth",
        description:["Authentication and Counter App build with React Redux and Redux Toolkit."],
       
        imgSrc:'https://github.com/marins1897/Redux-auth/blob/main/ReduxAuth.jpg?raw=true',
        demo:"https://redux-auth.vercel.app/",
        github:"https://github.com/marins1897/Redux-auth",
        type : "react"
    },
    {
        id:32,
        name:"Goal App",
        description:["Basic Goal App. List of Goals, delete and track Goals. Core Components and styling. Built with Expo."],
       
        imgSrc:'https://github.com/marins1897/Goal-App_react-native/blob/master/rn_course_app.png?raw=true',
        demo:"",
        github:"https://github.com/marins1897/Goal-App_react-native",
        type : "react-native"
    },
    {
        id:16,
        name:"Forms And User Input",
        description:["Working with forms and user input in React.js. Validating user input and providing validation feedback."],
       
        imgSrc:'https://github.com/marins1897/React-Form-and-UserInput-Validation/blob/main/FormsAndUserInput.jpg?raw=true',
        demo:"https://react-form-and-user-input-validation.vercel.app/",
        github:"https://github.com/marins1897/React-Form-and-UserInput-Validation",
        type : "react"
    },
    {
        id:17,
        name:"Visit Otok",
        description:["Website for tourist agency Visit Otok. Made by using HTML, CSS and Javascript. School project."],
       
        imgSrc:'https://github.com/marins1897/VisitOtok/blob/main/seminar/VisitOtok.jpg?raw=true',
        demo:"",
        github:"https://github.com/marins1897/VisitOtok/tree/main/seminar",
        type : ""
    },
    {
        id:18,
        name:"Login User",
        description:["Login User to Some Page with React Hooks, useContext, useReducer and useEffect."],
       
        imgSrc:'https://github.com/marins1897/LoginLogout-from-SomePage/blob/main/Login.jpg?raw=true',
        demo:"https://login-logout-from-some-page.vercel.app/",
        github:"https://github.com/marins1897/LoginLogout-from-SomePage",
        type : "react"
    },
    {
        id:19,
        name:"Animation Modal",
        description:["Using React Transition Group. "],
       
        imgSrc:'https://github.com/marins1897/AnimationsModal/blob/main/Animations.jpg?raw=true',
        demo:"https://animations-modal.vercel.app/",
        github:"https://github.com/marins1897/AnimationsModal",
        type : "react"
    },
    {
        id:20,
        name:"Favorite App",
        description:["Click on Product to make it Favorite. Made with custom Hooks."],
       
        imgSrc:'https://github.com/marins1897/Favorites-customHook/blob/main/Favorite.jpg?raw=true',
        demo:"https://favorites-custom-hook.vercel.app/",
        github:"https://github.com/marins1897/Favorites-customHook",
        type : "react"
    },
    {
        id:21,
        name:"Ingredients ",
        description:["Ingredient App made with React custom Hook. Add new Ingredient, filter ingredients and fetch and load ingredients with Firebase."],
       
        imgSrc:'https://github.com/marins1897/IngredientsList/blob/main/Ingredients.jpg?raw=true',
        demo:"https://ingredients-list-gamma.vercel.app/",
        github:"https://github.com/marins1897/IngredientsList",
        type : "react"
    },
    {
        id:22,
        name:"Add User App",
        description:["Add new User by submitting Form. Made with React useState."],
       
        imgSrc:'https://github.com/marins1897/AddUser/blob/main/AddUser.jpg?raw=true',
        demo:"https://add-user-psi.vercel.app/",
        github:"https://github.com/marins1897/AddUser",
        type : "react"
    },
    {
        id:23,
        name:"Goal App",
        description:["Add new goal. Made with React useState. Styling invalid input with CSS modules."],
       
        imgSrc:'https://github.com/marins1897/Add-InvalidInput/blob/main/Goal.jpg?raw=true',
        demo:"https://add-invalid-input.vercel.app/",
        github:"https://github.com/marins1897/Add-InvalidInput",
        type : "react"
    },
    {
        id:24,
        name:"Portfolio",
        description:["Personal portfolio made with HTML, CSS, Javascript."],
       
        imgSrc:'https://github.com/marins1897/Marin/blob/main/Portfolio.jpg?raw=true',
        demo:"http://www.marinsamardzic.ga/",
        github:"https://github.com/marins1897/Marin",
        type : ""
    },
    {
        id:25,
        name:"Show Hide User",
        description:["Show and Hide Added User made with React class based components."],
       
        imgSrc:'https://github.com/marins1897/Add-Hide-User/blob/main/ShowHide.jpg?raw=true',
        demo:"https://add-hide-user-eakacqr1k-marins1897.vercel.app/",
        github:"https://github.com/marins1897/Add-Hide-User",
        type : "react"
    },
    {
        id:26,
        name:"To Do",
        description:["To Do App builded by React Custom hook. Tasks added to Firebase and fetched."],
       
        imgSrc:'https://github.com/marins1897/ToDo-List-customHook/blob/main/CustomToDo.jpg?raw=true',
        demo:"https://to-do-list-custom-hook.vercel.app/",
        github:"https://github.com/marins1897/ToDo-List-customHook",
        type : "react"
    },
    {
        id:27,
        name:"Toggle",
        description:["A look behind the scenes of React and Optimization Techinques."],
       
        imgSrc:'https://github.com/marins1897/toggle_react/blob/master/toggle.png?raw=true',
        demo:"",
        github:"https://github.com/marins1897/toggle_react",
        type : "react"
    },

] 
